import { getCookie } from '../../../services/cookies';
import countrySettings from '../countrySettings.json';
import PatientServicesCL from './PatientServicesCL';
import PatientServicesPE from './PatientServicesPE';

const COMPONENTS = { CL: PatientServicesCL, PE: PatientServicesPE };

const PatientServices = (props) => {
  const countryCode = getCookie('country_code');
  const variant = countrySettings.componentVariant.patientServices[countryCode] ?? 'CL';
  const Component = COMPONENTS[variant];
  return <Component {...props} />;
};

export default PatientServices;
